import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { DattaConfig } from 'src/app/config/app-config';
import { UtilityService } from 'src/app/services/skyaccessconfig/utility.service';


@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  @Output() onNavCollapse = new EventEmitter();
  @Output() onNavCollapsedMob = new EventEmitter();
  @Input() IsSkyaccessApp : boolean = false;
  
  public dattaConfig: any;
  public navCollapsed;
  public navCollapsedMob;
  public windowWidth: number;

  constructor(private utilityService: UtilityService) {
    if(!this.IsSkyaccessApp)
      this.dattaConfig = DattaConfig.config;
    else 
      this.dattaConfig = DattaConfig.configApp;

    this.windowWidth = window.innerWidth;
    this.navCollapsed = (this.windowWidth >= 992) ? this.dattaConfig['collapse-menu'] : false;
    this.navCollapsedMob = false;
  }

  ngOnInit() {
    this.utilityService.isSkyAccess = this.IsSkyaccessApp;
  }

  navCollapse() {
    if (this.windowWidth >= 992) {
      this.navCollapsed = !this.navCollapsed;
      this.onNavCollapse.emit();
    }
  }


  navCollapseMob() {
    if (this.windowWidth < 992) {
      this.onNavCollapsedMob.emit();
    }
  }
}

